/**
 * Página principal del módulo de Tareas Cron
 * Muestra todas las tareas programadas con sus estados y permite ejecutarlas manualmente
 */
import React from 'react'
import { CRON_TASKS_CONFIG } from '../../config/cron/cronTasksConfig'
import { CronTaskCard } from '../../components/cron'
import { useCronTask } from '../../hooks/cron'

/**
 * Componente que renderiza una tarjeta de tarea cron individual
 * Usa el hook useCronTask para obtener los datos
 */
const CronTaskItem: React.FC<{ config: typeof CRON_TASKS_CONFIG[0] }> = ({
  config,
}) => {
  const task = useCronTask(config)

  return (
    <CronTaskCard
      config={config}
      status={task.status}
      count={task.count}
      isLoading={task.isLoading}
      error={task.error}
      countdown={task.countdown}
      onExecute={task.execute}
    />
  )
}

const CronTasks: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-2xl font-bold text-gray-900">Tareas Cron</h1>
          <p className="text-sm text-gray-500 mt-1">
            Gestiona y ejecuta manualmente las tareas programadas del sistema
          </p>
        </div>
      </div>

      {/* Grid de tareas */}
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 p-6">
          {CRON_TASKS_CONFIG.map((config) => (
            <CronTaskItem key={config.id} config={config} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default CronTasks

